export default [
  {
    label: '系统设置',
    icon: 'icon-setting',
    permission:'sys_set',
    id:'7',
    children: [
      {
        label: '基础设置',
        icon: 'icon-setting',
        path: '/order/set',
        permission: 'order_set',
        id:'7-1',
      },
      {
        label: '调度管理',
        icon: 'icon-yonghu',
        path: '/sys/manage',
        permission: 'sys_admin',
        id:'7-2',
      }
    ],
  },
];
